import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Input, Select, Row } from 'antd';
import { useHistory } from 'react-router';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import GetField from '../Components/GetField';
import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import { clearUnitIds, getUnitIds } from '../Actions';
import Breadcrumbs from '../Components/Breadcrumbs';

const AntInput = GetField(Input);
const AntSelect = GetField(Select);
const { Option } = Select;
const AntInputTextArea = GetField(Input.TextArea);

const CreateFabric = props => {
  const { classes } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit, control } = useForm();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const unitIds = useSelector(state => state.unitIds);

  useEffect(() => {
    dispatch(getUnitIds());
    return () => {
      dispatch(clearUnitIds());
    };
  }, []);

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.post('/fabrics', formValues);
      successNotification('Fabric created');
      history.push('/fabrics/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Fabric"
        moduleLink="/fabrics/list"
        subModuleName="Create"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Name"
                  placeholder="Name"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="quality"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Quality"
                  placeholder="Quality"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="count"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Count"
                  placeholder="Count"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="constructionRead"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  // type="number"
                  // min={0}
                  // step="any"
                  label="Construction Read"
                  placeholder="Construction Read"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="constructionPick"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  // type="number"
                  // min={0}
                  // step="any"
                  label="Construction Pick"
                  placeholder="Construction Pick"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="width"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  // type="number"
                  // min={0}
                  // step="any"
                  label="Width"
                  placeholder="Width"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="unitId"
              control={control}
              render={({ field }) => (
                <AntSelect
                  allowClear
                  label="Unit"
                  placeholder="Select unit"
                  {...field}
                >
                  {unitIds.map(unit => (
                    <Option key={unit.id} value={unit.id}>
                      {unit.unit}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="composition"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Composition"
                  placeholder="Composition"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="remark"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Remark"
                  placeholder="Remark"
                  {...field}
                />
              )}
            />
          </LeftGrid>
        </Row>
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

CreateFabric.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateFabric);
